export default (city, country) => {
  return [city, country].filter((el) => !!el).join(', ');
};
